module.exports = __webpack_public_path__ + "img/travel_step3_sucs.697b7745.svg";